/**
 * Product utility to help derive name and type based on locale and duration.
 */

import { t } from '@lingui/macro';
import { TDateUnit } from 'lendingApi/applications.types';
import { TAvailableProducts } from 'lendingApi/lendingApi.types';
import { getDurationInMonths } from './durationHelper';

type TDeriveProductFromTypeAndDuration = {
  productType?: TAvailableProducts;
  duration?: { amount: number; unit: TDateUnit } | null;
  isUK: boolean;
};

type TReturnDeriveProduct = {
  name: string;
  type: TAvailableProducts | null;
};

export const PRODUCT_NAMES = () => ({
  business_loan: 'Term Loan',
  term_loan: 'Term Loan',
  credit_facility: t`Flexi-Loan`,
  cbils: 'CBILS',
  iwocapay: 'iwocaPay',
  flexi24: t`Flexi-24`,
  recovery_loan: 'Recovery Loan',
  merchant_cash_advance: 'Revenue Based Loan',
});

export function deriveProductFromTypeAndDuration({
  productType,
  duration,
  isUK,
}: TDeriveProductFromTypeAndDuration): TReturnDeriveProduct {
  if (!productType) return { name: '-', type: null };

  const durationInMonths = getDurationInMonths(duration);
  if (productType === 'credit_facility') {
    if (isUK && durationInMonths === 60) {
      return { name: PRODUCT_NAMES().term_loan, type: 'term_loan' };
    }
    if (!isUK && durationInMonths === 24) {
      return { name: PRODUCT_NAMES().flexi24, type: 'flexi24' };
    }
  }

  if (PRODUCT_NAMES()[productType]) {
    return { name: PRODUCT_NAMES()[productType], type: productType };
  }

  return { name: '', type: null };
}
